"use strict";
/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable max-lines */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customSystemAddOnsTotalPrice = exports.customSystemBaseProductsPrice = exports.customSystemBaseProducts = exports.getFinalTotalPrice = exports.sequenceProducts = exports.getPackageProductsMiniCartItems = exports.getPackageMiniCartItems = exports.packageLineItemToMiniCartLineItems = exports.toMiniCartLineItems = exports.convertToKey = exports.IOMiniCart = exports.initializeMiniCart = exports.setMiniCartLineItem = exports.setMiniCartLoading = void 0;
const safeProp_1 = require("../../utils/safeProp");
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const always_1 = __importDefault(require("ramda/src/always"));
const gt_1 = __importDefault(require("ramda/src/gt"));
const ifElse_1 = __importDefault(require("ramda/src/ifElse"));
const multiply_1 = __importDefault(require("ramda/src/multiply"));
const path_1 = __importDefault(require("ramda/src/path"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const sum_1 = __importDefault(require("ramda/src/sum"));
const products_1 = require("../../commercetools/products");
const select_1 = require("../../redux/select");
const errorLogging_1 = require("../../thirdparty/errorLogging");
const setMiniCartLoading = (isLoading) => ({
    '@@type': 'minicart',
    payload: isLoading,
    type: 'SET_MINICART_LOADING'
});
exports.setMiniCartLoading = setMiniCartLoading;
const setMiniCartLineItem = (rawPayload) => {
    const { quantity, masterSku } = rawPayload;
    const updateAction = {
        '@@type': 'minicart',
        payload: (0, exports.convertToKey)(rawPayload),
        type: 'UPDATE_MINICART'
    };
    const removeAction = {
        '@@type': 'minicart',
        payload: masterSku,
        type: 'REMOVE_ITEM_FROM_MINICART'
    };
    return (0, ifElse_1.default)((q) => (0, gt_1.default)(q, 0), (0, always_1.default)(updateAction), (0, always_1.default)(removeAction))(quantity);
};
exports.setMiniCartLineItem = setMiniCartLineItem;
const initializeMiniCart = (lineItems) => ({
    '@@type': 'minicart',
    payload: lineItems,
    type: 'INITIALIZE_MINICART'
});
exports.initializeMiniCart = initializeMiniCart;
/**
 * Fetches shopping list from external source and populates Redux with results.
 *
 * @example
 * const dispatch = useDispatch()
 *
 * useEffect(() => {
 *   dispatch(IOMiniCart('01010101010101010100010101'))
 * }, [ dispatch ])
 */
const IOMiniCart = (attributeHash, handleFailure, handleSuccess) => (dispatch, getState) => {
    const locale = (0, select_1.selectLocale)(getState());
    dispatch((0, exports.setMiniCartLoading)(true));
    (0, products_1.commerceToolsRequestDynamicPackageList)(locale)(attributeHash)
        .pipe((0, fluture_1.map)(response => response.map((0, prop_1.default)('lineItems')).getOrElse([])))
        .pipe((0, fluture_1.map)((0, exports.toMiniCartLineItems)(getState())))
        .pipe((0, fluture_1.fork)((error) => {
        const action = {
            '@@type': 'minicart',
            payload: monet_1.Maybe.fromNull(error),
            type: 'INITIALIZE_MINICART_ERROR'
        };
        dispatch(action);
        (0, errorLogging_1.logError)(error);
        handleFailure && handleFailure();
    })((miniCartLineItems) => {
        dispatch((0, exports.initializeMiniCart)(miniCartLineItems));
        handleSuccess && handleSuccess();
    }));
};
exports.IOMiniCart = IOMiniCart;
const convertToKey = (rawPayload) => {
    const sku = (0, prop_1.default)('masterSku', rawPayload);
    return ({ [sku]: { ...rawPayload } });
};
exports.convertToKey = convertToKey;
/**
 * Transform a CT shopping list to MiniCartLineItems keyed by sku, using passed state.
 *
 * Fetches products/packages from state as needed, maintains quantities.
 */
const toMiniCartLineItems = (state) => (listLineItems = []) => listLineItems.flatMap(listLineItem => (0, exports.packageLineItemToMiniCartLineItems)(state)(listLineItem))
    .reduce((acc, lineItem) => {
    const keyed = (0, exports.convertToKey)(lineItem);
    return ({
        ...acc,
        ...keyed
    });
}, {});
exports.toMiniCartLineItems = toMiniCartLineItems;
/**
 * Transform a CT shopping list line item to an array of MiniCartLineItem using passed state.
 *
 * First, attempt to fetch a package by given SKU; if present, use its .products array to dictate child SKUs and quantities.
 * Second, attempt to fetch products by all present skus (package, package children, and line item itself); convert each to
 * returnable item.
 */
const packageLineItemToMiniCartLineItems = (state) => (listLineItem) => {
    // List of the package's included children, if the listLineItem is a package
    const bundleIncludedPackageChildren = (0, exports.getPackageMiniCartItems)(state)(listLineItem);
    // The details for the current listLineItem; tag it as a base bundle if it has included children
    const lineItemProduct = {
        isBaseBundle: bundleIncludedPackageChildren.length > 0,
        isBundleIncluded: false,
        isViewable: true,
        quantity: (0, prop_1.default)('quantity', listLineItem),
        sku: (0, path_1.default)(['custom', 'fields', 'master_sku'], listLineItem)
    };
    // List of the current line item, plus any of its included children if it is a package
    const packageProducts = bundleIncludedPackageChildren.concat(lineItemProduct);
    // Add product details to current line item and any included children
    return (0, exports.getPackageProductsMiniCartItems)(state)(packageProducts);
};
exports.packageLineItemToMiniCartLineItems = packageLineItemToMiniCartLineItems;
/**
 * Check if a SKU is a package and return an array of its possible children. Returns an empty array if the sku is not a package.
 */
const getPackageMiniCartItems = (state) => (listLineItem) => 
// disable error logging for this selector because the line item may not be a package
(0, select_1.selectPackage)((0, path_1.default)(['custom', 'fields', 'master_sku'], listLineItem), false)(state)
    .toMaybe()
    .map(pkg => (0, prop_1.default)('products', pkg))
    .getOrElse([])
    .map(packageProduct => ({
    ...packageProduct,
    isBaseBundle: false,
    isBundleIncluded: true,
    quantity: (0, prop_1.default)('quantity', packageProduct) * (0, prop_1.default)('quantity', listLineItem)
}));
exports.getPackageMiniCartItems = getPackageMiniCartItems;
/**
 * Evaluate an array of SKUs as products; transform to MiniCart line items
 */
const getPackageProductsMiniCartItems = (state) => (packageProducts) => (0, select_1.selectProducts)(packageProducts.map((0, prop_1.default)('sku')))(state)
    .cata(() => [], products => products
    .map(product => monet_1.List.from(packageProducts)
    .find(packageProduct => (0, prop_1.default)('sku', packageProduct) === (0, prop_1.default)('masterSku', product))
    .map(packageProduct => ({
    ...packageProduct,
    ...product,
    quantity: (0, prop_1.default)('quantity', packageProduct)
})))
    .filter(maybe => maybe.isSome())
    .map(maybe => maybe.just()));
exports.getPackageProductsMiniCartItems = getPackageProductsMiniCartItems;
// eslint-disable-next-line functional/prefer-readonly-type
function sequenceProducts(_products) {
    const EitherListOrError = monet_1.List.fromArray(_products)
        .sequenceEither()
        .map(_list => _list.toArray());
    EitherListOrError.leftMap(e => {
        return e;
    });
    return EitherListOrError;
}
exports.sequenceProducts = sequenceProducts;
// Returns a total price of a product based on its quantity in a package and price
const getFinalTotalPrice = (discounts) => (i) => monet_1.Maybe.fromUndefined(discounts)
    .chain(v => v.relativeDiscount)
    .map(percentOff => {
    // If there is a relative discount we subtract that amount from the total price
    const totalProductPrice = (0, multiply_1.default)(i.quantity, i.price);
    // Note: CT calculates each item and its discount rounted off to two decimal then muliplied by its quantity.
    const amountToDiscount = Number(((percentOff / 100) * i.price).toFixed(2)) * i.quantity;
    return Number((totalProductPrice - amountToDiscount).toFixed(2));
})
    .getOrElse(Number((i.price * i.quantity).toFixed(2)));
exports.getFinalTotalPrice = getFinalTotalPrice;
/**
 * Returns array containing Base products with BMS + default quantity for these products
 * Base products UK: Base Station, Keypad, SimpliCam
 * Base products US: Base Station, Keypad
 */
const customSystemBaseProducts = (state) => (_package) => (0, safeProp_1.safeProp)('products', _package).map(packageProducts => packageProducts.filter(packageProduct => !!(0, prop_1.default)('isViewable', packageProduct)))
    .map(packageProducts => packageProducts.map(packageProduct => {
    // TODO extract this function.
    const { sku, quantity } = packageProduct;
    const _product = (0, select_1.selectProduct)(sku)(state);
    return _product.map(p => ({
        ...p,
        quantity
    }));
}))
    .toEither(Error('The package does not contain any products'));
exports.customSystemBaseProducts = customSystemBaseProducts;
// formats sum of all sensors
const toFormattedNumber = (total) => Number(total.toFixed(2));
// Returns total price for BMS base products
const customSystemBaseProductsPrice = (state, _package, discounts) => {
    const baseProducts = _package
        .chain((0, exports.customSystemBaseProducts)(state))
        .chain(sequenceProducts);
    return baseProducts
        .map(p => p.map((0, exports.getFinalTotalPrice)(discounts)))
        .map(sum_1.default)
        .map(toFormattedNumber);
};
exports.customSystemBaseProductsPrice = customSystemBaseProductsPrice;
// Returns total price of sensors (MiniCart) added to BMS (excludes Base Products)
const customSystemAddOnsTotalPrice = (state, discounts) => {
    const miniCartProducts = (0, select_1.selectMiniCartLineItems)(state);
    return monet_1.Maybe
        .fromUndefined(miniCartProducts)
        .map(miniCartLineItem => miniCartLineItem.map((0, exports.getFinalTotalPrice)(discounts)))
        .map(sum_1.default)
        .map(toFormattedNumber);
};
exports.customSystemAddOnsTotalPrice = customSystemAddOnsTotalPrice;
//# sourceMappingURL=actions.js.map